import React from 'react';
import { Link } from 'react-router-dom';
import '../../index.scss'
import { Job } from '../../services/job/job.interface';

interface JobDetailProp {
  job: Job;
}
export default function JobDetail({
  job,
}: JobDetailProp) {
  const expandContent = (content: string) => {
    let c = content.trim().split('\n');

    return {
      title: c[0],
      content: c.splice(1).join('\n'),
    }
  }
  return (
    <>
      <div className="job-overview">
        <pre>{job.overview?.trim()}</pre>
      </div>
      
      <div className="job-feature">
        <div className="title">特徴</div>
        <div className="content">
          <pre>{job.feature?.trim()}</pre>
        </div>
      </div>

      <div className="job-contents">
        <div className="left">
        {job.images?.map((image, i) => (
          <img key={`job-image_${i}`} src={image.src} alt="" />
        ))}
        </div>
        <div className="right">
        {job.contents?.map((m, i) => {
          const {title, content} = expandContent(m);

          return (
            <div key={`job-content_${i}`} className="job-content">
              <div className="title">{title}</div>
              <div className="content">
                <pre>{content}</pre>
              </div>
            </div>
          );
        })}
        </div>
      </div>

      <div className="job-buttons">
        {(job.enabledVisit ?? true) && (
        <div className="button">
          <Link to={`/entry/visit/${job.type}`}><span>会社見学を申し込む</span></Link>
        </div>
        )}
        {(job.enabledRecruit ?? true) && (
        <div className="button">
          <Link to={`/entry/recruit/${job.type}`}><span>正社員／インターンを申し込む</span></Link>
        </div>
        )}
      </div>
    </>
  ); 
}